import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import SprintTournamentPresentational from '../components/sprintTournamentResults';
import * as  commonActions from '../actions/common';
import * as  sprintTournamentActions from '../actions/sprintTournament';
import * as  raceActions from '../actions/races';

class SprintTournamentResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updatePage: "",
      EventName: "",
      sprintTournamentList: [],
    }
    this.ExecuteUpdate = this.ExecuteUpdate.bind(this);
  }

  componentDidMount() {
    this.getParameters();
  }

  getParameters() {
    if (this.props.match !== undefined) {
      const { raceCode } = this.props.match.params
      this.getData(raceCode);
    } else {
      const { raceCode } = this.props
      this.getData(raceCode);
    }

  }

  getData(raceCode) {
    this.props.raceActions.getRace(raceCode)
      .then(() => {
        if (this.props.race.race !== null) {
          this.setState({
            EventName: this.props.race.race.EventName,
          });
        }
      });

    this.props.sprintTournamentActions.getSprintTournamentResults(raceCode)
      .then(() => {
        this.setState({
          sprintTournamentList: this.processSprints(this.props.sprintTournament.sprintTournamentResultList),
        });
      });
  }

  processSprints(list) {
    return list.map((item) => {
      var tempRiders = item.Riders.filter((item2) => {
        if (item2.Name !== "") {
          return item2;
        }
      });

      return { ...item, Riders: tempRiders };
    });
  }

  ExecuteUpdate() {
    this.getParameters();
  }

  render() {
    return <SprintTournamentPresentational {...this.state} {...this.props} ExecuteUpdate={this.ExecuteUpdate} />
  }
}

const mapStateToProps = (completeStore) => {
  return {
    sprintTournament: completeStore.sprintTournament,
    race: completeStore.race,
    updatePage: completeStore.updatePage,
  };
};

const mapDispatchToProps = (dispatch) =>
  ({
    sprintTournamentActions: bindActionCreators(sprintTournamentActions, dispatch),
    raceActions: bindActionCreators(raceActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  });

export default connect(mapStateToProps, mapDispatchToProps)(SprintTournamentResults);